import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62c27c03"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ticket-trend-container f1 fv" }
const _hoisted_2 = {
  class: "f1 fh-s-b",
  style: {"height":"11.7%"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fs16 color-06 bold" }, "工单量走势图", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "f1",
  style: {"height":"88.3%"}
}, [
  /*#__PURE__*/_createElementVNode("div", { id: "ticket-trend" })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menuItem = _resolveComponent("a-menuItem")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_dropdown, { style: {"width":"200px"} }, {
        overlay: _withCtx(() => [
          _createVNode(_component_a_menu, { class: "menu" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setTime('THIS_DAY')))
                  }, "今日")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTime('THIS_WEEK')))
                  }, "本周")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTime('THIS_MONTH')))
                  }, "本月")
                ]),
                _: 1
              }),
              _createVNode(_component_a_menuItem, null, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    href: "javascript:;",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setTime('THIS_YEAR')))
                  }, "本年")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "fs12 color-primary",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
          }, _toDisplayString(_ctx.timeFilter(_ctx.timeRef)), 1)
        ]),
        _: 1
      })
    ]),
    _hoisted_4
  ]))
}